import { connect } from 'react-redux';
import RunReportButton from '../../components/widgets/RunReportButton';
import { runQuery, setActionType } from '../../actions/reports';
import { reportDataSelectors } from '../../selectors/reports';
import { reportTypes } from '../../utils/reports';

const mapStateToProps = (state, ownProps) => {
    const { reportDates, disableReportState, reportFormHasChanged, ...props } = reportDataSelectors[
        ownProps.reportType
    ](state);
    const startDate = reportDates.start_date;
    const endDate = reportDates.end_date;

    let disabled = !(startDate && endDate) || !!disableReportState || !reportFormHasChanged;

    if (ownProps.reportType === reportTypes.creativeExplore) {
        disabled = disabled || !props.selectedSources?.length || !props.selectedApps?.length;
    }

    return {
        ...ownProps,
        disableReportState,
        disabled,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const { onClick, ...otherProps } = ownProps;
    return {
        ...otherProps,
        onClick: () => {
            onClick && onClick();
            dispatch(setActionType(runQuery(ownProps.reportType, ownProps.reportType, {}), ownProps.reportType));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RunReportButton);
